import {NgModule} from '@angular/core';
import {TeConfigPage} from "./page/overview/config/te-config.page";
import {TeTemplateObjectComponent} from "./component/protected-components/te-template/te-template-object.component";
import {TeArtefactObjectComponent} from "./component/protected-components/te-artefact/te-artefact-object.component";
import {TreeModule} from 'primeng/tree';
import {TeEditorComponent} from "./component/protected-components/te-editor/te-editor.component";
import {TeVariablesComponent} from './component/protected-components/te-variables/te-variables.component';
import {
    EmbeddedArtefactsComponent
} from './component/protected-components/embedded-artefacts/embedded-artefacts.component';
import {TeVariableService} from './service/te-variable.service';
import {ContextMenuModule} from 'primeng/contextmenu';
import {TeTestCaseComponent} from './component/protected-components/te-test-case/te-test-case.component';
import {
    TeTestCaseSetupComponent
} from './component/protected-components/te-test-case-setup/te-test-case-setup.component';
import {
    TeTestCaseResultComponent
} from './component/protected-components/te-test-case-result/te-test-case-result.component';
import {
    TeVariableDialogComponent
} from './component/protected-components/te-variables-dialog/te-variables-dialog.component';
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {SkeletonModule} from "primeng/skeleton";
import {TeConfigTestPage} from "./page/overview/config-test/te-config-test.page";
import {
    TableInfoConditionsComponent
} from "./component/protected-components/te-editor/components/table-info-conditions/table-info-conditions.component";
import {CmModule} from "../../feature-crm/cm/cm.module";
import {NsModule} from "../ns/ns.module";
import {
    CodeMirrorEditorComponent
} from "./component/protected-components/te-editor/components/code-mirror-editor/code-mirror-editor.component";
import {TeOverviewPage} from "./page/te-overview-page/te-overview.page";
import {TeKpiComponent} from "./page/te-overview-page/components/kpiComponent/te-kpi.component";
import {TeStatisticsComponent} from "./page/te-overview-page/components/statisticsComponent/te-statistics.component";
import {
    TeTemplateObjectSideComponent
} from "./component/protected-components/te-template/view/te-template-object-side/te-template-object-side.component";
import {
    TeTemplateObjectFullComponent
} from "./component/protected-components/te-template/view/te-template-object-full/te-template-object-full.component";
import {
    TeTemplateObjectBaseComponent
} from "./component/protected-components/te-template/view/te-template-object-base.component";
import {
    TeArtefactObjectFullComponent
} from "./component/protected-components/te-artefact/view/te-artefact-object-full/te-artefact-object-full.component";
import {
    TeArtefactObjectSideComponent
} from "./component/protected-components/te-artefact/view/te-artefact-object-side/te-artefact-object-side.component";
import {
    TeArtefactObjectBaseComponent
} from "./component/protected-components/te-artefact/view/te-artefact-object-base.component";
import {TeBlueprintObjectComponent} from "./component/protected-components/te-blueprint/te-blueprint-object.component";
import {
    TeBlueprintObjectBaseComponent
} from "./component/protected-components/te-blueprint/view/te-blueprint-object-base.component";
import {
    TeBlueprintObjectSideComponent
} from "./component/protected-components/te-blueprint/view/te-blueprint-object-side/te-blueprint-object-side.component";
import {
    TeBlueprintObjectFullComponent
} from "./component/protected-components/te-blueprint/view/te-blueprint-object-full/te-blueprint-object-full.component";
import {
    TeAiVariableSuggestionPanelComponent
} from "./component/protected-components/te-ai/te-ai-variable-suggestion-panel.component";
import {TeAiTestDataDialogComponent} from "./component/protected-components/te-ai/te-ai-test-data-dialog.component";
import {
    TeAiDocumentUploadDialogComponent
} from "./component/protected-components/te-ai/te-ai-document-upload-dialog.component";
import {TeAiAnalysisPage} from "./page/ai-analysis/te-ai-analysis.page";
import {TE_ENTITY_PROVIDER} from "./te.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {PMessagesComponent} from "../../core/shared/p-messages/p-messages.component";
import {EditorComponent} from "@tinymce/tinymce-angular";
import {TE_TEST_PROVIDERS} from "./test/te-test-definition";
import {TeIfDialogComponent} from "./component/protected-components/te-if-dialog/te-if-dialog.component";
import {TeCopyPopoverComponent} from "./component/protected-components/te-copy-popover/te-copy-popover.component";
import {TeTableBuilderDialogComponent} from "./component/protected-components/te-table-builder-dialog/te-table-builder-dialog.component";
import {TeEditorCommunicationService} from "./service/te-editor-communication.service";
import {SplitterModule} from "primeng/splitter";
import {TabsModule} from "primeng/tabs";
import {IconField} from "primeng/iconfield";
import {InputIcon} from "primeng/inputicon";


@NgModule({
    imports: [
        CoreModule,
        TreeModule,
        ContextMenuModule,
        ProgressSpinnerModule,
        SkeletonModule,
        CmModule,
        NsModule,
        PMessagesComponent,
        EditorComponent,
        SplitterModule,
        TabsModule,
        IconField,
        InputIcon,
    ],

    declarations: [
        TeConfigPage,
        TeTemplateObjectComponent,
        TeArtefactObjectComponent,
        TeEditorComponent,
        TeVariablesComponent,
        EmbeddedArtefactsComponent,
        TeTestCaseComponent,
        TeTestCaseSetupComponent,
        TeTestCaseResultComponent,
        TeVariableDialogComponent,
        TeConfigTestPage,
        TableInfoConditionsComponent,
        CodeMirrorEditorComponent,
        TeOverviewPage,
        TeKpiComponent,
        TeStatisticsComponent,
        TeTemplateObjectSideComponent,
        TeTemplateObjectFullComponent,
        TeTemplateObjectBaseComponent,
        TeArtefactObjectFullComponent,
        TeArtefactObjectSideComponent,
        TeArtefactObjectBaseComponent,
        TeBlueprintObjectComponent,
        TeBlueprintObjectBaseComponent,
        TeBlueprintObjectSideComponent,
        TeBlueprintObjectFullComponent,
        TeAiVariableSuggestionPanelComponent,
        TeAiTestDataDialogComponent,
        TeAiDocumentUploadDialogComponent,
        TeAiAnalysisPage,
        TeIfDialogComponent,
        TeCopyPopoverComponent,
        TeTableBuilderDialogComponent,
    ],
    exports: [
        TeConfigPage,
        TeTemplateObjectComponent,
        TeArtefactObjectComponent,
        TeEditorComponent,
        TeVariablesComponent,
        TeVariableDialogComponent,
        TeConfigTestPage,
        TableInfoConditionsComponent,
        CodeMirrorEditorComponent,
        TeTemplateObjectSideComponent,
        TeTemplateObjectFullComponent,
        TeTemplateObjectBaseComponent,
        TeArtefactObjectFullComponent,
        TeArtefactObjectSideComponent,
        TeArtefactObjectBaseComponent,
        TeBlueprintObjectComponent,
        TeBlueprintObjectBaseComponent,
        TeBlueprintObjectSideComponent,
        TeBlueprintObjectFullComponent,
        TeAiVariableSuggestionPanelComponent,
        TeAiTestDataDialogComponent,
        TeAiDocumentUploadDialogComponent,
    ],
    providers: [
        TeVariableService,
        TeEditorCommunicationService,
        ProgressSpinnerModule,
        TE_ENTITY_PROVIDER,
        TE_TEST_PROVIDERS
    ]

})
export class TeModule implements DynamicModule {

    alias = 'te';

    constructor(private moduleRegistry: ModuleRegistryService) {
        this.moduleRegistry.registerModule(this);
    }

    getKpiComponent() {
        return TeKpiComponent;
    }

    getStatisticsComponent() {
        return TeStatisticsComponent;
    }
}

